import { FONT } from "@/styles/common";
import { Flex } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomWrapper = styled(Flex)`
    position: relative;
    width: 100%;
    gap: 24px;
    box-sizing: border-box;
    ${FONT("pretendard", 16, 500)};
`;
